export default {
    formInit() {
        return {
            selectedClassName: null,
            classNameOptions: [{ value: null, text: "Class 1" }],
            selectedInstructor: null,
            instructorOptions: [{ value: null, text: "Instructor 1" }],
            selectedScheduleColor: "blue",
            scheduleColorOptions: [
                { value: "blue", text: "Blue" },
                { value: "red", text: "Red" },
                { value: "orange", text: "Orange" },
                { value: "purple", text: "Purple" },
                { value: "green", text: "Green" },
                { value: "pink", text: "Pink" },
                { value: "gray", text: "Gray" }
            ],
            selectedBranch: null,
            selectedBranchName: null,
            branchOptions: [{ value: null, text: "Branch 1" }],
            selectedRoom: null,
            roomOptions: [{ value: null, text: "Room 1" }],
            date: new Date(),
            startTime: {
                HH: "09",
                mm: "00",
                ss: "00"
            },
            endTime: {
                HH: "10",
                mm: "00",
                ss: "00"
            },
            recurrence: false,
            selectedDays: ["mon"],
            daysOptions: [
                { text: "Sun", value: "sun" },
                { text: "Mon", value: "mon" },
                { text: "Tue", value: "tue" },
                { text: "Wed", value: "wed" },
                { text: "Thu", value: "thu" },
                { text: "Fri", value: "fri" },
                { text: "Sat", value: "sat" }
            ],
            endDate: new Date(),
            capacity: 0,
            visibility: true
        };
    }
};
